export class Regle {
    map;
    balise;
    clickLong;
    clickMesure;
    pointMesure;
    movePoint;
    flightPath;
    fixePoint;
    tabflightPaths;
    tabMarkers;
    isActive;
    constructor(map) {
        this.map = map;
        const longueurLink = document.createElement("a");
        longueurLink.textContent = "Règle";
        longueurLink.className = 'w-auto inactive';
        longueurLink.href = "#";
        longueurLink.id = "Longueur";
        longueurLink.title = trans.get('common.add');
        const that = this;
        longueurLink.addEventListener('click', function() {
            that.onClickMenu.bind(that);
            that.onClickMenu();
        });
        this.fixePoint = [];
        this.pointMesure = [];
        this.balise = longueurLink;
        this.tabflightPaths = [];
        this.tabMarkers = [];
        this.balise.classList.add('inactive');
    }
    getItemMenu() {
        return this.balise;
    }
    onClickMenu(){
        // nous etions en mode "actif" 
        if (this.isActive) {
            // on desactive
            this.map.setOptions({ draggableCursor: 'grab' });
            this.balise.classList.remove('active');
            this.balise.classList.add('inactive');
            google.maps.event.clearListeners(this.map, 'click');
            google.maps.event.clearListeners(this.map, 'rightclick');
            google.maps.event.clearListeners(this.map, 'mousemove');

            this.tabflightPaths.forEach(element => {
                google.maps.event.clearListeners(element,'click');
                google.maps.event.clearListeners(element,'mouseover');
                google.maps.event.clearListeners(element,'mouseout'); 
            });
            this.clickMesure = 0;

            //on retire le bouton de suppression
            if ( document.getElementById("deletePolylign")) {
                document.getElementById("deletePolylign").remove();
            }
            
            this.isActive = false;
        } else {
            this.clickMesure = 0;

            // on réinitialise les champs et on active le mode
            this.balise.classList.remove('inactive');
            this.balise.classList.add('active');
            this.map.setOptions({ draggableCursor: 'crosshair' });

            this.addBouttoncorbeille();
            
            // retire l'evenement sur les règles 
            google.maps.event.clearListeners(this.map, 'click');

            // on ajoute les events listeners sur la map
            const that = this;
            google.maps.event.addListener(this.map, "click", function(e) {
                that.handleClickOnMap.bind(that);
                that.handleClickOnMap(e);
            });
            this.isActive = true;

            //rend clickable les règles existantes
            if(this.tabflightPaths.length!=0){
                this.tabflightPaths.forEach(element => {
                   this.addEventsPolylines(element);
                });
            }
        }
    }
    handleClickOnMap(evt) {
        var fixMesure = document.createElement('div');
        fixMesure.className = 'mesure';

        this.clickMesure++;
        const that = this;
       
        google.maps.event.addListener(this.map, "mousemove", function(e) {
            that.handleMouseMoveOnMap.bind(that);
            that.handleMouseMoveOnMap(e);
        });

        google.maps.event.addListener(this.map, "rightclick", function(e) {
            that.handleRightClickOnMap.bind(that);
            that.handleRightClickOnMap(e);
        });

        var path = this.pointMesure;
        if (this.clickMesure == 1) {
            this.flightPath = new google.maps.Polyline({
                path: path,
                map: null,
                geodesic: true,
                strokeColor: "#FF0000",
                strokeOpacity: 1.0,
                strokeWeight: 2,
                clickable: false,
                properties:{
                    'id':this.tabflightPaths.length ,
                    }
            });

            this.movePoint = new google.maps.marker.AdvancedMarkerElement({
                map:this.map,
            })
            
            //ajout dans le tableau regroupant les polylines
            this.tabflightPaths.push(this.flightPath);

            //ajout sur la map
            this.tabflightPaths.forEach(element => {
                element.setMap(this.map);  
            });                    
        }

        this.pointMesure.push({
            'lat': evt.latLng.lat(),
            'lng': evt.latLng.lng(),
        });

        if (this.clickMesure > 1) {
            var dist = Math.round(turf.distance(
                [this.pointMesure[this.clickMesure - 2].lng, this.pointMesure[this.clickMesure - 2].lat],
                [this.pointMesure[this.clickMesure - 1].lng, this.pointMesure[this.clickMesure - 1].lat]
            ) * 1000);
            var temp = turf.points([
                [this.pointMesure[this.clickMesure - 2].lng, this.pointMesure[this.clickMesure - 2].lat],
                [this.pointMesure[this.clickMesure - 1].lng, this.pointMesure[this.clickMesure - 1].lat]
            ]);
            var center = turf.center(temp).geometry.coordinates;
            
            fixMesure.textContent = dist + " m";

            this.fixePoint.push(new google.maps.marker.AdvancedMarkerElement({
                map: this.map,
                position :{
                    'lat': center[1] + 0.00001,
                    'lng': center[0],
                },
                content : fixMesure
            }));
        }
    }
    handleMouseMoveOnMap(evt) {        
        
        if (this.pointMesure.length > 0) {

            var movingMesure =  document.createElement('div');
            movingMesure.className="mesure";

            this.pointMesure[this.clickMesure] = {
                'lat': evt.latLng.lat(),
                'lng': evt.latLng.lng(),
            };

            var dist = Math.round(turf.distance(
                [this.pointMesure[this.clickMesure - 1].lng, this.pointMesure[this.clickMesure - 1].lat],
                [this.pointMesure[this.clickMesure].lng, this.pointMesure[this.clickMesure].lat]
            ) * 1000);

            var temp = turf.points([
                [this.pointMesure[this.clickMesure - 1].lng, this.pointMesure[this.clickMesure - 1].lat],
                [this.pointMesure[this.clickMesure].lng, this.pointMesure[this.clickMesure].lat]
            ]);
            var center = turf.center(temp).geometry.coordinates;

            this.movePoint.position = {
                'lat': center[1] + 0.00001,
                'lng': center[0],
            };

            movingMesure.textContent = dist + " m";
            this.movePoint.content = movingMesure

            this.flightPath.setPath(this.pointMesure);
        }
    }
    handleRightClickOnMap(){
        //on retire les listeners pour pouvoir créer plusieurs polyligns
        google.maps.event.clearListeners(this.map, 'rightclick');
        google.maps.event.clearListeners(this.map, 'mousemove');
        
        //Ajout du tableau de labels dans un super tableau afin que les indices du tableau de polyligns correspondent avec celui des labels
        //ex: tabMarkers[x] contient les markers (labels) du polylign : tabflightPaths[X]
        this.tabMarkers.push(this.fixePoint);
        this.fixePoint=[];

        var current= (this.tabflightPaths.length)-1;

        var polylign=this.tabflightPaths[current];

        this.addEventsPolylines(polylign);

        if (this.pointMesure.length > 0) {
            //on retire le bouton de suppression
            if (!document.getElementById("deletePolylign")) {
                this.addBouttoncorbeille();
            }
            this.clickMesure=0;
            // we remove last point
            this.pointMesure.pop();

            this.movePoint.setMap(null);
            this.movePoint.position = null;
            this.movePoint=null;
            
            this.flightPath.setPath(this.pointMesure);
            this.pointMesure=[];
        }
    }
    addBouttoncorbeille(){
        // Delete polyline button
        const div = document.createElement("div");
        div.id = "deletePolylign";
        div.classList = "btn-trash";
        div.innerHTML = this.getCorbeilleBtnHtmlCode();

        this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(div);
       
        div.onclick = (e) => {

            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();
            this.cleanMap();
            
            //on retire le bouton de suppression
            document.getElementById("deletePolylign").remove();
        }
    }
    cleanMap(){

        //les polylines de la map 
        if(this.tabflightPaths.length>0){
            this.tabflightPaths.forEach(element=>{
                element.setMap(null);      
            })
            this.tabflightPaths=[];
        }

        //Les markers (labels)
        if(this.tabMarkers.length>0) {
            this.tabMarkers.forEach(tab=>{
                tab.forEach(e=>{
                    e.setMap(null);
                })
            });
            this.tabMarkers=[];
        }

        //les points de mouvements
        if(this.flightPath) {
            this.flightPath.setPath(this.pointMesure);
            this.flightPath.setMap(null);
            this.flightPath = null;
        }
        this.pointMesure = [];
    }
    addEventsPolylines(polylign){
        //Evenement de suppression des polyligns
        polylign.setOptions({ clickable: true});

        polylign.addListener("click",()=>{

            var indexPlacement = polylign.properties.id;
            //remove polyline
            polylign.setMap(null);
            this.tabflightPaths.splice(indexPlacement,1);

            //remove marker
            this.tabMarkers[indexPlacement].forEach(labelPoint => {
                labelPoint.setMap(null);
            });
            this.tabMarkers.splice(indexPlacement,1);         
            
            //update propertie to use as index for delete
            this.tabflightPaths.forEach(element => {
                if (element.properties.id>indexPlacement) {
                    element.properties.id--;
                }
            });
        })

        polylign.addListener("mouseover",()=>{
            polylign.setOptions({ strokeWeight: 5})
            this.map.setOptions({ draggableCursor: 'grab' });
        })

        polylign.addListener("mouseout",()=>{
            this.map.setOptions({ draggableCursor: 'crosshair' });
            polylign.setOptions({ strokeWeight: 2})
        })
    }
    getCorbeilleBtnHtmlCode(){
        return `<a class="buttonOriginal">
                    <span class="glyphicon glyphicon-trash" title="Supprimer les règles"></span>
                </a>`;
    }
}
export default Regle;